import type { IconData } from '@stacksjs/iconify-core'

export const gl4x3: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h640v480H0z\"/><path fill=\"#d00c33\" d=\"M0 240h640v240H0zm80 0a160 160 0 1 0 320 0a160 160 0 0 0-320 0\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default gl4x3
